import PageHeader from '../../../Layout/PageHeader'
import { useNavigate, useParams } from "react-router-dom";
import { SubmitHandler, useForm  } from "react-hook-form";
import { useEffect, useState } from "react";
import FormButton from "../../../Components/Buttons/FormButton";
import CustomizableTableForAddAndEdit from "../../../Components/Tables/CustomizableTableForAddAndEdit";
import { DataFromAPI, dropDownFromList, dropDownItemCode, dropDownToList, initialData, InvStatusList } from "../../../Data/testData";
import Select from 'react-select';
import CustomPlaceholder, { customStyles } from '../../../Shared/Select/CustomPlaceholder';
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import FormSelect from "../../../Components/FormTag/FormSelect";
import InputFiled from "../../../Components/FormTag/InputFiled";
import { InventoryStatusOptions } from '../../../Data/replenishmentData';
import { replenishmentCreate } from "./ReplenishmentCreate.type";
import { PATTERN_ERR_MSG } from "../../../Shared/Helper/ValidationMessage";
import {
  ALPHANUM_SPACE_REGEX,
  DATE_REGEX,
} from "../../../Shared/Helper/Constant";

export default function ReplenishmentEdit() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const pageName = `Replenishment`;

  const [isShowCanvas, setShowCanvas] = useState(false);
  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };

  const [createreplenishmentData, setCreatereplenishmentData] = useState<replenishmentCreate>(
    new replenishmentCreate()
  );

  useEffect(() => {
    setCollapseStates((prev) => prev.map(() => true));
  }, []);
  const {
    register,
    setValue,
    control,
    formState: { errors },
  } = useForm<replenishmentCreate>({
    defaultValues: createreplenishmentData,
  });

  useEffect(() => {
    setValue('fromInventoryStatus', InventoryStatusOptions[0].value);
    setValue('toInventoryStatus', InventoryStatusOptions[0].value);
  }, [setValue, InventoryStatusOptions]);

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      width: '125px !important',    // Set the width of the input box
      fontSize: '14px',  // Adjust font size if needed
      padding: 0
    }), menu: (provided: any) => ({
      ...provided,
      width: '125px',    // Set the width of the dropdown menu
    }),
  };

  const customStylesForInvStats = {
    control: (provided: any) => ({
      ...provided,
      width: '130px !important',    // Set the width of the input box
      fontSize: '14px',  // Adjust font size if needed
    }), menu: (provided: any) => ({
      ...provided,
      width: '130px',    // Set the width of the dropdown menu
    }),
  };


  const backNavigate = () => {
    return navigate(`/inventory/replenishment/details/${id}`);
  }

  const handleClose = () => {
    backNavigate();
  }

  const save = () => {
    backNavigate();
  }

  const columns = [
    { key: 'lineNumber', label: 'Line #', disable: true },
    { key: 'itemCode', label: 'Item Code', inputType: <span className="customDropdown"><Select components={{ Placeholder: CustomPlaceholder }} styles={customStyles} options={dropDownItemCode} /> </span>, disable: true },
    { key: 'itemDescription', label: 'Item Description', disable: true, customStyles: { width: '182px' } },
    { key: 'uom', label: 'UOM', disable: true },
    { key: 'from', label: 'From', inputType: <Select options={dropDownFromList} styles={customStyles} /> },
    { key: 'to', label: 'To', inputType: <Select options={dropDownToList} styles={customStyles} /> },
    { key: 'transferQty', label: 'Transfer Qty', disable: true, customStyles: { width: '110px' } },
    { key: 'invStatus', label: 'Inv Status', inputType: <Select options={InvStatusList} styles={customStylesForInvStats} />, customStyles: { width: '160px' } },
  ];

  return (
    <>
      <PageHeader
        listUrl={`/inventory/replenishment/details/${id}`}
        viewType={true}
        isHistoryEnabled={true}
      />

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-1 px-2 d-flex flex-column">
        <div className="checkin-details col-12 bg-white col-12 py-1 py-4 px-1 ">

          {collapseStates[0] ? (
            <div className="mt-2 bg-white rounded py-3 px-2">
              <div className="d-flex justify-content-between">
                <div className="d-flex col-10 justify-content-between">
                  <div>
                    <div className="label-light-grey fs-14">Transfer Date</div>
                    <label>15/03/2020</label>
                  </div>
                  <div>
                    <div className="label-light-grey fs-14">From Inventory Status</div>
                    <label>Finished Goods</label>
                  </div>
                  <div>
                    <div className="label-light-grey fs-14">To Inventory Status</div>
                    <label>Found Inventory</label>
                  </div>
                </div>
                <div className="align-self-center">
                  <span
                    className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
                    onClick={() => toggleCollapse(0)}
                  >
                    {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                  </span>
                </div>

              </div>
            </div>
          ) : (
            <div className="">
              <form>
                <div className="d-flex gap-3 ">
                  <div className="col-5 px-2">
                    <label className="fw-medium">Transfer Date</label>
                    <div className="mt-1">
                      <InputFiled
                        type="date"
                        tabIndex={8}
                        register={register}
                        name="transferDate"
                        errors={errors.transferDate}
                        pattern={{
                          type: DATE_REGEX,
                          message: PATTERN_ERR_MSG,
                        }}
                        className="form-control"
                        placeholder="mm/dd/yyyy"
                      />
                    </div>
                  </div>
                  <div className="col-5 px-2">
                    <label className="fw-medium">From Inventory Status</label>
                    <div className="mt-1">
                      <FormSelect
                        name="fromInventoryStatus"
                        tabIndex={2}
                        control={control}
                        optionList={InventoryStatusOptions}
                        className="form-control p-0"
                        placeholder="Select"
                        isSearchable={true}
                      />
                    </div>
                  </div>
                  <div className="col-1 px-2 mb-3">
                <div className="align-self-center d-flex flex-row-reverse">
                <span
                  className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
                  onClick={() => toggleCollapse(0)}
                >
                  {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
                </span>
              </div>
                </div>
                </div>
                <div className="d-flex mt-3 gap-3 ">
                  <div className="col-5 px-2">
                    <label className="fw-medium">To Inventory Status</label>
                    <div className="mt-1">
                      <FormSelect
                        name="toInventoryStatus"
                        tabIndex={2}
                        control={control}
                        optionList={InventoryStatusOptions}
                        className="form-control p-0"
                        placeholder="Select"
                        isSearchable={true}
                      />
                    </div>
                  </div>
                  <div className="col-5 px-2">
                    <label className="fw-medium">Custom Field 1</label>
                    <div className="mt-1">
                      <InputFiled
                        type="text"
                        tabIndex={4}
                        register={register}
                        name="customField1"
                        errors={errors.customField1}
                        pattern={{
                          type: ALPHANUM_SPACE_REGEX,
                          message: PATTERN_ERR_MSG,
                        }}
                        className="form-control"
                        placeholder="Enter"
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex mt-3 gap-3 ">
                  <div className="col-5 px-2">
                    <label className="fw-medium">Custom Field 2</label>
                    <div className="mt-1">
                      <InputFiled
                        type="text"
                        tabIndex={5}
                        register={register}
                        name="customField2"
                        errors={errors.customField2}
                        pattern={{
                          type: ALPHANUM_SPACE_REGEX,
                          message: PATTERN_ERR_MSG,
                        }}
                        className="form-control"
                        placeholder="Enter"
                      />
                    </div>
                  </div>
                </div>
              </form>
              
            </div>
          )}
        </div>
      </div>
      <div className="my-2 bg-white rounded py-1 px-3 CustomizedTable h-100 d-flex flex-column">
        <CustomizableTableForAddAndEdit
          columns={columns} initialData={initialData}
          customClassName="replenishmentEditCustomTable d-flex flex-column h-100" dataFromAPI={DataFromAPI} filterColumn="itemCode" />
      </div>
      <div className="mt-auto bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={25}
            className="sph-btn me-4"
            handleClick={() => handleClose()}>
            Submit
          </FormButton>
          <FormButton
            tabIndex={26}
            className="sph-btn sph-shift me-4"
            handleClick={() => handleClose()}>
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
}
